import { useState } from 'react'
import { useNotificationBar } from 'context/notificationContext'

interface Props {
    widget: {
        value: string;
        label: string;
        code: string;
    };
    initialData?: any;
    onSave: (payload: any) => void;
    onCancel?: () => void;
}
const pageTypeOptions = [
    { value: 'category', label: 'Category' },
    { value: 'collection', label: 'Collection' },
    { value: 'show', label: 'Show' },
]

const HeaderWidget = ({ widget, initialData, onSave }: Props) => {
    const notification = useNotificationBar()
    console.log('initialData .//,,..', initialData)
    const [widgetTypeName, setWidgetTypeName] = useState(widget.label || 'header_widget')
    const [widgetName, setWidgetName] = useState(initialData?.name || 'Header Widget');
    const [pageType, setPageType] = useState(initialData?.page_type || 'header_widget');


    const handleSave = () => {
        if (!widgetName || !pageType) {
            notification.push({
                message: 'Please fill all required fields',
                type: 'error',
            })
            return
        }
        if (!widgetTypeName) {
            notification.push({
                message: 'Widget Type is required',
                type: 'error',
            })
            return
        }

        const finalData = {
            name: widgetName,
            widget_code: widget.code,
            widget_type: Number(widget.value),
            content_type: 'STATIC',
            page_type: pageType,
            source_type: 'MANUAL',
        }

        onSave(finalData)

        // ✅ SUCCESS NOTIFICATION
        notification.push({
            title: 'Success',
            message: 'Header widget saved successfully',
            type: 'success',
        })
    }

    const handleCancel = () => {
        onSave(initialData || null)
    }



    return (
        <div className="space-y-4">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">

                {/* Widget Type */}
                <div className='flex flex-col gap-1'>
                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Widget Type</label>
                    <input
                        value={widgetTypeName}
                        readOnly
                        className="w-full px-3 py-2 text-sm border rounded-lg
   bg-gray-100 text-gray-700 cursor-not-allowed
   dark:bg-slate-700 dark:text-gray-300 dark:border-slate-600"
                        placeholder="Enter widget type name"
                    />
                </div>
            </div>
            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl"> */}


            {/* Widget Name */}
            {/* <div className='flex flex-col gap-1'>
                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Widget Name</label>
                    <input
                        value={widgetName}
                        onChange={(e) => setWidgetName(e.target.value)}
                        className="w-full px-3 py-2 text-sm border rounded-lg
 bg-white text-gray-900 placeholder-gray-400
 focus:ring-2 focus:ring-blue-500
 dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder-gray-500"
                        placeholder="Enter widget name"
                    />
                </div> */}
            {/* </div> */}
            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">

                <div className='flex flex-col gap-1'>
                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Page Type</label>
                    <select
                        value={pageType}
                        onChange={(e) => setPageType(e.target.value)}
                        className="w-full px-3 py-2 text-sm border rounded-lg
 bg-white text-gray-900 placeholder-gray-400
 focus:ring-2 focus:ring-blue-500
 dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder-gray-500"
                    >
                        <option value="">Select PageType</option>
                        {pageTypeOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div> */}

            {/* Actions */}
            <div className="flex justify-end gap-3 pt-6 mt-6 border-t border-gray-200 dark:border-slate-600">


                <button
                    onClick={handleCancel}
                    className="px-6 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
                >
                    Cancel
                </button>
                <button
                    onClick={handleSave}
                    className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default HeaderWidget
